// src/api/user/class.api.js
import api from '../client';

/**
 * GET /user/classes
 * 현재 로그인 사용자가 등록된 강의(class) 목록.
 * 각 항목에는 allowed_model_ids / primary_model_id / class_id 등이 포함된다.
 *
 * @param {object} [params]
 * @param {string} [params.status]   active | completed | inactive | dropped
 * @param {number} [params.limit]
 * @param {number} [params.offset]
 * @returns {Promise<{ items: Array, total: number, page: number, size: number }>}
 */
export const listMyClasses = (params) =>
  api.get('/user/classes', { params }).then((r) => r.data);

/** items 배열에서 class_id 일치 항목 검색 */
export const findMyClassById = (items, classId) => {
  if (!Array.isArray(items)) return null;
  const target = Number(classId);
  if (!Number.isFinite(target)) return null;
  return items.find((it) => Number(it.class_id) === target) || null;
};
